import { useEffect, useState } from "react"
import { useSharedCurrentStep } from "../_functions"
import CreateBuildingPage from "./create-building"
import BuildingLayoutMaps from "./building-layout-maps"
import { parseAsBoolean, parseAsInteger, useQueryState } from "nuqs";
import CreateMapScreen from "../layout-maps/_form/create";
import ListRobotScreen from "./_components/robot-list";
import { RobotType } from "../../../hooks/robot/index.type";
import ListRobotMapScreen from "./_components/robot-map-list";
import { MapType } from "../../../hooks/map.type";
import BindRobotMapScreen from "./bind-robot-map";
import CreateRobotQuickSetup from "./create-robot";
import CreateRobotMapScreen from "../robot-map/_form/create-map";
import OverlaySetting from "../../../components/RobotMap/models/OverlaySetting";
import AssignRobotMapToRobotScreen from "./assign-robot-map-to-robot";
import LocationPointScreen from "./location-point";
import { useNavigate } from "react-router-dom";
import { create } from "domain";
import ListWaypointPage from "./list-location";
import { BUILDING_UUID_PARAM_KEY } from "../_const";
import CreateLocationPage from "../location/create/page";
import ListGISBindRobotMapScreen from "./list-bind-gis-point/list";
import CreateGISBindRobotMapScreen from "./list-bind-gis-point/create";
import EditRobotMapScreen from "../robot-map/_form/edit-map";
import EditRobotScreen from "../robot/edit";
import { Box } from "@mui/material";
import { is } from "date-fns/locale";

export default function QuickSetupPage() {
  const [step, setStep] = useQueryState("step", parseAsInteger.withDefault(1).withOptions({
    history: "push"
  }));
  const [mock, setMock] = useQueryState("mock");
  const [currentBuildingId, setCurrentBuildingId] = useQueryState(BUILDING_UUID_PARAM_KEY, { clearOnDefault: true })
  const [isCreateNew, setIsCreateNew] = useQueryState("isCreateNew", parseAsBoolean.withDefault(false).withOptions({
    history: "push"
  }));
  const [selectedEdit, setSelectedEdit] = useState('')
  const [selectedRobots, setSelectedRobots] = useState<RobotType[]>([])
  const [selectedRobotMaps, setSelectedRobotMaps] = useState<MapType[]>([])
  const [selectedFloorMaps, setSelectedFloorMaps] = useState<MapType[]>([])
  const navigate = useNavigate()

  const isEdit = (selectedEdit !== '')

  const onHandleEdit = (id: string) => {
    setSelectedEdit(id)
  }

  const onSubmitRobot = (robots: RobotType[]) => {
    setStep(5)
  }

  const onSubmitRobotMaps = (robotMaps: MapType[]) => {
    setStep(6)
  }

  const onSubmitBindRobotMaps = ({
    robotMaps,
    floorMaps,
    robotOverlaySettings
  }: {
    robotMaps: MapType[],
    floorMaps: MapType[],
    robotOverlaySettings: OverlaySetting[]
  }) => {
    onNextStep()
  }

  useEffect(() => {
    if (!selectedRobotMaps || selectedRobotMaps.length === 0) {
      return
    }

    if (step < 6) {
      setStep(6)
      setMock(null)
    }
  }, [selectedRobotMaps, selectedRobotMaps.length])

  const onNextStep = () => {
    setStep(step + 1)
    setMock(null)
  }

  const onSubmitWaypoint = () => {
    setIsCreateNew(false)
  }

  const onNextWaypoint = () => {
    onNextStep()
    setMock(null)
  }

  useEffect(() => {
    if (step < 1) {
      setStep(1)
      return
    }
    if (step > 1 && !currentBuildingId) {
      setStep(1)
    }
  }, [step])

  const onSubmitAssignRobot = () => {
    onDone()
  }

  const onDone = () => {
    navigate('/config/buildings')
  }
  return (
    <>
      {step === 1 && (
        <CreateBuildingPage onSuccess={(val) => {
          setCurrentBuildingId(val)
          onNextStep()
          setMock(null)
        }} />
      )}
      {step === 2 && !isCreateNew && !isEdit && (
        <BuildingLayoutMaps
          id={currentBuildingId || ''}
          onCreateNew={() => setIsCreateNew(true)}
          onNext={(maps) => {
            setSelectedFloorMaps(maps)
            onNextStep()
          }}
          onEdit={(mapId) => {
            onHandleEdit(mapId)
          }}
        />
      )}
      {step === 2 && isCreateNew && (
        <CreateMapScreen
          // selectedBuildingId={currentBuildingId}
          onSuccess={() => {
            setMock('data')
            setIsCreateNew(false)
          }}
          onCancel={() => {
            setIsCreateNew(false)
          }}
        />
      )}
      {step === 2 && isEdit && !!selectedEdit && (
        <CreateMapScreen
          // selectedBuildingId={currentBuildingId}
          selectedMapId={selectedEdit}
          onSuccess={() => {
            setSelectedEdit('')
          }}
        />
      )}

      {step === 3 && isCreateNew && (
        <CreateLocationPage onSuccess={() => {
          onSubmitWaypoint()
        }} />
      )}

      {step === 3 && !isCreateNew && (
        <ListWaypointPage
          onCreate={() => {
            setIsCreateNew(true)
          }}
          onNext={onNextWaypoint}
        />
      )}

      {step === 4 && !isCreateNew && !isEdit && (
        <ListRobotScreen
          defaultSelectedRobots={selectedRobots}
          onCreateNew={() => setIsCreateNew(true)}
          onSubmitRobot={onSubmitRobot}
          onHandleEdit={(robotId) => setSelectedEdit(robotId)}
        />
      )}

      {step === 4 && isEdit && !isCreateNew && (
        <Box sx={{ padding: '36px' }}>
          <EditRobotScreen
            robotId={selectedEdit}
            onSubmit={() => setSelectedEdit('')}
            onCancel={() => setSelectedEdit('')}
          />
        </Box>
      )}

      {step === 4 && isCreateNew && (
        <CreateRobotQuickSetup
          onSubmit={() => {
            setIsCreateNew(false)
          }}
          selectedBuildingId={currentBuildingId || ''}
          onCancel={() => {
            setIsCreateNew(false)
          }}
        />
      )}

      {step === 5 && (
        <>
          {!isCreateNew && (
            <ListRobotMapScreen
              onSubmitRobotMaps={onSubmitRobotMaps}
              onCreateNew={() => {
                setIsCreateNew(true)
              }}
            />
          )}
          {isCreateNew && (
            <CreateRobotMapScreen
              onSuccess={() => {
                setIsCreateNew(false)
              }}
              onCancel={() => {
                setIsCreateNew(false)
              }}
            />
          )}
        </>
      )}

      {step === 6 && !isCreateNew && (
        <ListGISBindRobotMapScreen
          onNext={() => {
            onNextStep()
          }}
          onCreate={() => setIsCreateNew(true)}
        />
      )}

      {step === 6 && isCreateNew && (
        <CreateGISBindRobotMapScreen
          onSubmit={() => {
            setIsCreateNew(false)
          }}
          onCancel={() => setIsCreateNew(false)}
        />
      )}

      {step === 7 && (
        <AssignRobotMapToRobotScreen
          onSubmit={onSubmitAssignRobot}
          nextLabel="Done"
        />
      )}
    </>
  )
}